import { Navigate, Route, Routes } from "react-router-dom";
import { ParentQuests } from "../components/admin/ParentAdmin/KidInfo/Quests";
import { ParentNotifications } from "../components/admin/ParentAdmin/Notifications/Notifications";
import { ParentCreateNotification } from "../components/admin/ParentAdmin/Notifications/CreateNotification";
import { ParentKidRegister } from "../components/admin/ParentAdmin/Register/Kid";
import { ParentPayment } from "../components/admin/ParentAdmin/Register/Payment/Payment";
import ProtectedRoute from "../components/admin/SuperAdmin/ProtectedRoutes/ProtectedRoutes";
import { ParentPaymentUpdate } from "../components/admin/ParentAdmin/Register/Payment/PaymentUpdate";
import { ParentAdminCertificateView } from "../components/admin/ParentAdmin/KidInfo/Awards/Certificate/Certificates";
import { ParentAdminTrophyView } from "../components/admin/ParentAdmin/KidInfo/Awards/Trophy/Trophy";
import { QuestInfo } from "../components/admin/ParentAdmin/KidInfo/QuestInfo";
import ParentLayout from "../components/admin/ParentAdmin/Layout/ParentLayout";
import { SchlParentDashboard } from "../components/admin/ParentAdmin/Dashboard/SchlParentDashboard";
import ParentDashboardGuard from "../components/admin/ParentAdmin/ParentDashboardGuard";
import { SchlParentSettings } from "../components/admin/ParentAdmin/Account/SchlParentSettings";
import { SchoolParentQuests } from "../components/admin/ParentAdmin/KidInfo/SchlParentQuests";
import { SchoolParentQuestInfo } from "../components/admin/ParentAdmin/KidInfo/SchlParentQuestInfo";
import { SchlStudentNotifications } from "../components/admin/StudentAdmin/Notification/StudentNotification";
import { SchlStudentNotificationDetail } from "../components/admin/StudentAdmin/Notification/StudentNotificationDetail";

const SchoolParentAdminRoutes = () => (
  <>
    <Routes>
      <Route
        path=""
        element={
          <ProtectedRoute requiredRole={2}>
            <ParentDashboardGuard dashboard="school_parent">
              <ParentLayout parentType="school_parent" type="pcnormal" />
            </ParentDashboardGuard>
          </ProtectedRoute>
        }
      >
        <Route path="dashboard/" element={<SchlParentDashboard />} />
        <Route path="quests/:studentId" element={<SchoolParentQuests />} />
        <Route
          path="quests/:studentId/:questId"
          element={<SchoolParentQuestInfo />}
        />
        <Route
          path="quests/:kidId/:kidName/quest/:type"
          element={<QuestInfo />}
        />
        <Route
          path="quests/:kidId/:kidName/:questId/viewCertificate"
          element={<ParentAdminCertificateView />}
        />
        <Route
          path="quests/:kidId/viewTrophy"
          element={<ParentAdminTrophyView />}
        />
        <Route path="quests" element={<ParentQuests />} />
        <Route path="notifications" element={<ParentNotifications />} />
        <Route
          path="notification/create"
          element={<ParentCreateNotification />}
        />
        <Route path="settings" element={<SchlParentSettings />} />

        <Route
          path="kids/register/:kidCount/:kidSubscribed"
          element={<ParentKidRegister />}
        />

        <Route
          path="reciever/notifications"
          element={<SchlStudentNotifications type="pcnormal" />}
        />
        <Route
          path="reciever/notification/view/:id"
          element={<SchlStudentNotificationDetail type="pcnormal" />}
        />

        <Route path="payment" element={<ParentPayment />} />

        <Route path="payment/update" element={<ParentPaymentUpdate />} />
        <Route path="*" element={<Navigate to="/not-found" replace />} />
      </Route>
      {/* update case */}
    </Routes>
  </>
);

export default SchoolParentAdminRoutes;
